// apps/spa/src/hooks/useChannels.ts
// TanStack Query wrapper for the GET /api/channels endpoint (03-00).
//
// staleTime 5 min matches the worker's KV cache TTL — the SPA does not refetch
// on focus while the server cache is still fresh, so officers see consistent
// channel ordering across tabs without stamping the server every render.

import { useQuery } from '@tanstack/react-query';
import type { ChannelOption } from '@guardian/shared';
import { api } from '@/lib/api';

export function useChannels() {
  return useQuery({
    queryKey: ['channels'] as const,
    queryFn: () => api<ChannelOption[]>('/api/channels'),
    staleTime: 5 * 60 * 1000,
  });
}
